import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

const ANNOUNCEMENT = {
  startAt: "2026-06-16T13:40:00-04:00",
  endAt: "2026-06-17T10:00:00-04:00",
  message:
    "R-Link Studio will have scheduled maintenance on Wednesday, June 17th from 6am EST to 10am EST. You may see brief interruptions during this window. Thank you for your patience.",
};

const DASHBOARD_ROUTE_PREFIX = "/dashboard";

function isAnnouncementActive(now = Date.now()) {
  const start = new Date(ANNOUNCEMENT.startAt).getTime();
  const end = new Date(ANNOUNCEMENT.endAt).getTime();
  return Number.isFinite(start) && Number.isFinite(end) && now >= start && now <= end;
}

export default function CutoverAnnouncementBar() {
  const { pathname } = useLocation();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = window.setInterval(() => setNow(Date.now()), 30000);
    return () => window.clearInterval(interval);
  }, []);

  const isDashboardRoute = useMemo(
    () => pathname.startsWith(DASHBOARD_ROUTE_PREFIX),
    [pathname]
  );

  if (!isDashboardRoute || !isAnnouncementActive(now)) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 2147483000,
        width: "100%",
        background:
          "linear-gradient(90deg, #001233 0%, #2f176f 45%, #004d40 100%)",
        color: "#ffffff",
        borderBottom: "1px solid rgba(255, 255, 255, 0.22)",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.28)",
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: "0 auto",
          padding: "10px 18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          textAlign: "center",
          fontFamily:
            "Lato, Montserrat, Poppins, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
          fontSize: 14,
          fontWeight: 700,
          lineHeight: 1.35,
          letterSpacing: 0,
        }}
      >
        <span
          aria-hidden="true"
          style={{
            display: "inline-flex",
            width: 8,
            height: 8,
            borderRadius: "999px",
            background: "#00c853",
            boxShadow: "0 0 0 5px rgba(0, 200, 83, 0.18)",
            flex: "0 0 auto",
          }}
        />
        <span>{ANNOUNCEMENT.message}</span>
      </div>
    </div>
  );
}

export { isAnnouncementActive };
